import getSelectedMediaAssetIdsForChannel from './getSelectedMediaAssetIdsForChannel';
import { collectSyncAltConflictsForChannel } from './collectSyncAltConflicts';

export const buildMediaAltTextForChannel = ({
  channelId,
  product,
  productsState,
  productMediaByChannel = {},
  variantMediaByChannel = {},
  masterVariantIds,
  isVariantSync = false,
  userResolutions = {},
}) => {
  const { autoResolved } = collectSyncAltConflictsForChannel({
    channelId,
    product,
    productsState,
    productMediaByChannel,
    variantMediaByChannel,
    masterVariantIds,
    isVariantSync,
  });

  const selectedAssetIds = getSelectedMediaAssetIdsForChannel({
    channelId,
    productMediaByChannel,
    variantMediaByChannel,
    isVariantSync,
  });

  return selectedAssetIds.map((assetId) => {
    const normalizedAssetId = String(assetId);
    const resolvedAlt = userResolutions[normalizedAssetId] ?? autoResolved[normalizedAssetId] ?? '';

    return {
      assetId: normalizedAssetId,
      altText: resolvedAlt,
    };
  });
};

export default function buildMediaAltTextByChannel({
  selectedChannels = [],
  userResolutionsByChannel = {},
  ...params
}) {
  return selectedChannels.reduce((acc, channelId) => {
    acc[channelId] = buildMediaAltTextForChannel({
      channelId,
      userResolutions: userResolutionsByChannel[channelId] || {},
      ...params,
    });
    return acc;
  }, {});
}
